import React, { useEffect, useState } from "react";
import Lottie from "react-lottie-player";
import clickAnimation from "./clickAnimation.json";

export default function HelpingHand() {
  const [hide, setHide] = useState(false);
  useEffect(() => {
    setTimeout(() => setHide(true), 5000);
  }, []);
  return (
    <>
      {!hide && (
        <div className="h-[100%] w-[70px] z-10 absolute right-0 bottom-[-20px]">
          <Lottie loop animationData={clickAnimation} play />
        </div>
      )}
    </>
  );
}
